import { render } from "./Bench.vue?vue&type=template&id=19869f89&scoped=true&ts=true"
import script from "./Bench.vue?vue&type=script&lang=ts"
export * from "./Bench.vue?vue&type=script&lang=ts"

import "./Bench.vue?vue&type=style&index=0&id=19869f89&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19869f89"]])

export default __exports__